import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getapprovalListHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "approvallist", ...action.payload }),
		);
		yield put({
			type: types.GET_APPROVAL_LIST_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_APPROVAL_LIST_ERROR,
			payload,
		});
	}
}

export function* getapprovalListWatcherSaga() {
	yield takeLatest(types.GET_APPROVAL_LIST_START, getapprovalListHandlerSaga);
}

//create

//delete

function* deleteapprovalListHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("approvallist", action.payload),
		);
		yield put({
			type: types.DELETE_APPROVAL_LIST_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_APPROVAL_LIST_ERROR,
			payload,
		});
	}
}

export function* deleteapprovalListWatcherSaga() {
	yield takeLatest(
		types.DELETE_APPROVAL_LIST_START,
		deleteapprovalListHandlerSaga,
	);
}

//update
